import { render, staticRenderFns } from "./MobileTotal.vue?vue&type=template&id=c6c5809a&"
import script from "./MobileTotal.vue?vue&type=script&lang=ts&"
export * from "./MobileTotal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports